<div class="row pad-top-40">
  @if (errorOnANS$ | async) {
    <div
      data-cy="sendToAgentErrorContainer"
      class="column twelve lg-eight lg-push-two md-eight md-push-two"
    >
      <ds-error-message [errorList]="errors"></ds-error-message>
    </div>
  }
  <div class="row column twelve lg-push-two md-eight md-push-two">
    <h2
      data-cy="quickQuoteReviewHeader"
      dsContent
      [contentPath]="'policy.quoteVehicleReviewHeader'"
      class="col-12 font-weight-bold"
    ></h2>
    <risk-item [riskDescription]="newRiskDescription$ | async"></risk-item>
    <div class="row margin-bottom-40">
      <div class="column twelve">
        <premium-details [quotes]="premiumDetails"></premium-details>
      </div>
    </div>
    <div class="row pad-bottom-20 flex">
      <span class="control-label pad-right-10"></span>
      <span
        dsContent
        [contentPath]="
          (context$ | async) === 'REPLACE_VEHICLE'
            ? 'policy.replaceVehicleQuoteInfoTextOnlineBind'
            : 'policy.replaceVehicleQuoteInfoTextOnlineQuote'
        "
        [options]="{ currentVehicle: (existingVehicleRiskDescription$ | async) }"
        class="column twelve items-center"
      >
      </span>
    </div>
    <div class="row">
      <div class="column twelve">
        <blockquote class="border -primary-800">
          <p dsContent [contentPath]="'policy.replaceVehicletermsText'"></p>
        </blockquote>
      </div>
    </div>
    <call-to-action
      [displayBackButton]="true"
      [secondaryButtonName]="
        (context$ | async) === 'REPLACE_VEHICLE' ? 'Send to my agent' : 'GET ANOTHER QUOTE'
      "
      [primaryButtonName]="
        (context$ | async) === 'REPLACE_VEHICLE' ? 'Continue' : 'SEND TO MY AGENT'
      "
      [backButtonName]="
        (context$ | async) === 'REPLACE_VEHICLE' ? 'Get Another Quote' : 'Back to Vehicle Details'
      "
      (primaryEvent)="handlePrimaryEventTrigger()"
      (secondaryEvent)="handleTertiaryEventTrigger()"
      (backEvent)="handleSecondaryEventTrigger()"
    ></call-to-action>
  </div>
</div>
